import { css } from 'linaria';

export const text = css`
  && {
    width: 879px;
    margin-bottom: 40px;
    line-height: 28px;

    @media (--to-desktop) {
      width: auto;
      margin-bottom: 24px;
    }

    @media (--only-mobile) {
      font-size: 14px;
      line-height: 18px;
    }
  }
`;

export const typeItem = css`
  && {
    width: 277px;
    margin-right: 24px;

    :last-of-type {
      margin-right: 0;
    }

    @media (--only-desktop) {
      width: 217px;
    }

    @media (--to-desktop) {
      width: 210px;
    }
  }
`;

export const typeImage = css`
  display: block;
  width: 100%;
  height: 262px;
  margin-bottom: 24px;
  border-radius: var(--rounding-l);
  object-fit: cover;

  @media (--only-desktop) {
    height: 204px;
  }

  @media (--to-desktop) {
    height: 148px;
  }
`;
